import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail, trackEvent } from "@/lib/api";
import { Send, Loader2 } from "lucide-react";

export default function EnquiryForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/enquiries", form);
      trackEvent("enquiry_submitted", "/");
      toast.success("Enquiry sent — Jesse will be in touch within 1 business day.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-cream-soft border border-sand/80 rounded-2xl px-5 py-3.5 text-ink placeholder:text-ink-soft/60 focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors font-sans";

  return (
    <form
      onSubmit={onSubmit}
      data-testid="enquiry-form"
      className="space-y-4"
    >
      <div className="grid sm:grid-cols-2 gap-4">
        <input
          data-testid="enquiry-name-input"
          name="name"
          required
          minLength={2}
          placeholder="Your name"
          value={form.name}
          onChange={onChange}
          className={inputCls}
        />
        <input
          data-testid="enquiry-email-input"
          name="email"
          type="email"
          required
          placeholder="Email address"
          value={form.email}
          onChange={onChange}
          className={inputCls}
        />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <input
          data-testid="enquiry-phone-input"
          name="phone"
          placeholder="Phone (optional)"
          value={form.phone}
          onChange={onChange}
          className={inputCls}
        />
        <input
          data-testid="enquiry-subject-input"
          name="subject"
          placeholder="Subject (optional)"
          value={form.subject}
          onChange={onChange}
          className={inputCls}
        />
      </div>
      <textarea
        data-testid="enquiry-message-input"
        name="message"
        required
        minLength={5}
        placeholder="Tell Jesse a little about what you're hoping for from counselling…"
        rows={5}
        value={form.message}
        onChange={onChange}
        className={`${inputCls} resize-none`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="enquiry-submit-button"
        className="inline-flex items-center gap-2 rounded-full bg-navy text-cream px-7 py-3.5 text-sm font-medium hover:bg-navy-deep hover:-translate-y-0.5 shadow-[0_12px_30px_-12px_rgba(14,59,74,0.75)] transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
        {loading ? "Sending…" : "Send enquiry"}
      </button>
      <p className="text-xs text-ink-soft pt-1">
        Your message stays private. Jesse replies personally — usually within one business day.
      </p>
    </form>
  );
}
